import { render, staticRenderFns } from "./DZL001_Result.vue?vue&type=template&id=3b8dc1a6&scoped=true&"
import script from "./DZL001_Result.vue?vue&type=script&lang=js&"
export * from "./DZL001_Result.vue?vue&type=script&lang=js&"
import style0 from "./DZL001_Result.vue?vue&type=style&index=0&id=3b8dc1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8dc1a6",
  null
  
)

export default component.exports